module.exports = __webpack_public_path__ + "static/img/03.35ae1fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/swee/tutorial/03.svg
// module id = wjs4
// module chunks = 13